<template>
  <v-container fluid>
    <v-row justify="center">
      <v-col>
        <v-card>
          <v-data-table
            :headers="headers"
            :items="accounts"
            :footer-props="datatable_footer"
            no-data-text="Нет данных для отображения"
          >
            <template v-slot:top>
              <v-card flat>
                <v-card-text>
                  <v-row dense>
                    <v-col
                      cols="12"
                      md="3"
                    >
                      <autocomplete
                        ref="autocomplete"

                        :get-result-value="getResultValue"
                        :search="search"
                        @submit="onSubmit"
                      />
                    </v-col>
                    <v-col
                      cols="12"
                      sm="3"
                      md="2"
                    >
                      <v-btn
                        color="primary"
                        outlined
                        @click="onOpenFilter"
                      >
                        <v-icon class="ml-3">
                          mdi-filter-variant
                        </v-icon>
                        <span class="mx-3">ФИЛЬТРЫ</span>
                      </v-btn>
                    </v-col>
                    <v-col
                      cols="12"
                      md="7"
                      class="d-flex justify-md-end"
                    >
                      <v-btn
                        class="ma-0"
                        outlined
                        color="secondary"
                        @click="downloadReport"
                      >
                        <v-icon class="ml-3">
                          mdi-download
                        </v-icon>
                        <span class="mx-3">Выгрузить</span>
                      </v-btn>
                      <v-icon
                        medium
                        class="icon-table"
                        @click="onOpenHeader"
                      >
                        mdi-table-cog
                      </v-icon>
                    </v-col>
                  </v-row>
                  <v-row>
                    <div>
                      <v-chip
                        v-for="(filter, index) in filterStuff"
                        v-show="filter.fieldValue !== '' && filter.fieldValue !== undefined"
                        :key="'i' + index"
                        close
                        @click:close="onClearFilter(filter)"
                      >
                        <span>{{ filter.fieldName }}: {{ filter.fieldValue }}</span>
                      </v-chip>
                    </div>
                  </v-row>
                </v-card-text>
              </v-card>
            </template>
            <template v-slot:item.actions="{ item }">
              <task-menu
                @edit="editItem(item)"
              />
            </template>
            <template v-slot:footer.page-text="{pageStart,pageStop,itemsLength}">
              {{ pageStart }}-{{ pageStop }} из {{ itemsLength }}
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <filter-dialog
          :dialog-visible="filterDialogVisible"
          :filter-label="filterLabel"
          :filter-stuff="filterStuff"
          @close="onCloseFilter"
          @filter="onSetFilter"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <header-dialog
          :dialog-visible="headerDialogVisible"
          :dialog-headers="dialogHeaders"
          @close="onCloseHeader"
          @header="onSetHeader"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import WebApi from "../../shared/modules/web_api"
import TaskMenu from "../../shared/components/task-menu/TaskMenu"
import AccountListViewModel from "../../models/account-list-view.model"
import { downloadCsvFile, getCsvFile } from "@/views/loyalty/shared/modules/utilities"
import Autocomplete from "@/views/loyalty/shared/components/search-autocomplete/Autocomplete"
import FilterDialog from "@/views/loyalty/shared/components/filter/FilterDialog"
import { FilterItem, FilterStuff } from "@/views/loyalty/shared/classes/filter_stuff"
import HeaderDialog from "@/views/loyalty/shared/components/header/HeaderDialog"
import { HeaderService } from "@/views/loyalty/shared/services/header_service"
import { AccountHeadersModel } from "@/views/loyalty/models/account.model"
import { JustpayClient } from "@/views/loyalty/shared/services/justpay-client-service"
import { AccountService } from "@/views/loyalty/shared/services/account-service"

export default {
  name: "AccountCustomerList",
  components: { Autocomplete, FilterDialog, HeaderDialog, TaskMenu },
  data: () => ({
    accounts: [],
      accountService: null,
      customerNumber: null,
    datatable_footer: {
      itemsPerPageText: 'Показывать по',
      pageText: 'из',
      itemsPerPageAllText: 'Все',
    },
    dialogHeaders: [],
    dialogVisible: false,
    dialogCorrectionVisible: false,
    filterDialogVisible: false,
    filterLabel: 'account.filter',
    filterStuff: [],
      justpayClientService: null,
    headerDialogVisible: false,
    headers: [],
    headerService: null,
    role: 0,
    selectedAccount: {},
    selectedCorrectionAccount: {},
    user: null,
    webApi: null
  }),
  async beforeMount () {
    const that = this
    localStorage.removeItem(this.filterLabel)
      this.accountService = new AccountService()
      this.headerService = new HeaderService(AccountHeadersModel)
      this.justpayClientService = new JustpayClient()
      this.webApi = new WebApi(this.$store).readError("Ошибка при чтении данных")
      this.webApi.get(`${process.env.VUE_APP_LOYALTY_URL}api/header/account/${this.$store.state.client ? this.$store.state.client.id : "0"}`)
          .then(async function (data) {
            console.log('header data', data)
            that.dialogHeaders = await that.headerService.get_header(data)
            console.log('that.dialogHeaders', that.dialogHeaders)
            that.headers = await that.headerService.get_header_list(data)
            console.log('that.headers', that.headers)
          })

    this.fillFilterStuff()
  },
  async mounted () {
      const customerId = this.$store.state.client ? this.$store.state.client.id : null
      this.customerNumber = await this.justpayClientService.getClientNumber(customerId)
      console.log('customerNumber', this.customerNumber)
      console.log('this.$route.params.role', this.$route.params.role)
      this.role = +this.$route.params.role
      this.user = this.role === 1 ? 'admin' : 'client'
    this.accounts = await this.getItems()
    console.log('mounted accounts', this.accounts)
    console.log('mounted headers', this.headers)
  },
  methods: {
    downloadReport () {
      let csvContent =
          "Программа лояльности;Описание;Счёт зачисления;Сумма;Счёт списания;Сумма;\n"
      csvContent += getCsvFile(this.accounts)
      downloadCsvFile("AccountCustomerReport", csvContent)
    },
    editItem (item) {
      console.log("item", item)
      // this.$store.dispatch("account_store/updateAccount", item)
      this.$router.push(
        `/${this.user}/accountcustomer/edit/${this.role}/${item.campaign.campaignId}/${item.campaign.customerId}`
        // name: "AccountCustomerEditLink",
        // params: {
        //   role: this.role.toString(),
        //   campaign: item.Campaign.campaignId,
        //   customer: item.Campaign.customerId
        // }
      )
    },
    fillFilterStuff () {
      this.filterStuff = new FilterStuff()
      this.filterStuff.add(new FilterItem().fieldName("Имя программы").fieldValue("").fieldType("text").value)
      this.filterStuff.add(new FilterItem().fieldName("Счёт по дебиту (Счёт списания бонусов)").fieldValue("").fieldType("text").value)
      this.filterStuff.add(new FilterItem().fieldName("Счёт по кредиту (Счёт начисления бонусов)").fieldValue("").fieldType("text").value)
      this.filterStuff = this.filterStuff.items
      console.log('filterStuff', this.filterStuff)
      return this.filterStuff
    },
    async getItems () {
      console.log('role', this.role)
        let accounts = []
      if (this.role === 1) {
          accounts = await this.accountService.getAllCustomerAccounts()
      }
      if (this.role === 2) {
          accounts = await this.accountService.createAccount(this.customerNumber)
        console.log(this.customerNumber)
      }
      console.log('accounts', accounts)
        return accounts.map(item => this.setItem(item))
    },
    getResultValue (result) {
      return result.searched
    },
    onClearFilter (filter) {
      console.log('filter', filter)
      const attrFilter = JSON.parse(localStorage.getItem(this.filterLabel))
      const newFilter = attrFilter.filter(f => { if (f.fieldValue === filter.fieldValue) { f.fieldValue = ""; return true } else { return true } })
      console.log('newFilter', newFilter)
      localStorage.setItem(this.filterLabel, JSON.stringify(newFilter))
      this.onSetFilter()
    },
    onCloseFilter () {
      const filterStuff = JSON.parse(localStorage.getItem(this.filterLabel))
      console.log('const filterStuff', filterStuff)
      this.filterStuff = filterStuff || this.fillFilterStuff()
      console.log('onCloseFilter this.filterStuff', this.filterStuff)
      this.filterDialogVisible = false
    },
    onCloseHeader () {
      this.headerDialogVisible = false
    },
    onOpenFilter () {
      this.filterDialogVisible = true
    },
    onOpenHeader () {
      const that = this
      this.headerDialogVisible = true
      this.webApi.get(`${process.env.VUE_APP_LOYALTY_URL}api/header/account/${this.$store.state.client ? this.$store.state.client.id : "0"}`)
          .then(async function (data) {
            console.log('header data', data)
            that.dialogHeaders = await that.headerService.get_header(data)
          })
    },
    async onSetFilter () {
      // this.accounts.map(data => {
      //   console.log('getItems() data', data)
        // const attrFilter = JSON.parse(localStorage.getItem(this.filterLabel))
        this.filterStuff = JSON.parse(localStorage.getItem(this.filterLabel)) || ''
        // console.log('attrFilter', attrFilter)
        this.filterDialogVisible = false
        // this.filterStuff = new FilterStuff(attrFilter).items
        console.log('this.filterStuff', this.filterStuff)
        if (this.filterStuff.length > 0) {
          this.accounts = await this.getItems().then(data => {
            return data.filter(f =>
                (f.campaign.name.includes(this.filterStuff[0].fieldValue) || this.filterStuff[0].fieldValue.length === 0) &&
                (f.accountAccrual.amount.toString().includes(this.filterStuff[1].fieldValue) || this.filterStuff[1].fieldValue.length === 0) &&
                (f.accountEmission.amount.toString().includes(this.filterStuff[2].fieldValue) || this.filterStuff[2].fieldValue.length === 0))
          })
        } else {
          this.accounts = await this.getItems() // .map(i => this.setItem(i))
        }
        console.log('this.accounts', this.accounts)
      // })
    },
    async onSetHeader (value) {
      const that = this
      console.log('onSetHeader', value)
      this.dialogHeaders = value
      this.headerDialogVisible = false
      const headers = await this.headerService.set_header("account", this.$store.state.client ? this.$store.state.client.id : "0", value)
      console.log('headers', headers)
      this.webApi.post(`${process.env.VUE_APP_LOYALTY_URL}api/header/`, headers)
      that.headers = await that.headerService.get_header_list(headers)
    },
    onSubmit (result) {
      const searching = result.searched ? result.searched : result
      if (searching.length !== 0) {
        this.accounts = this.accounts.filter(item => (
          item.campaign.name.includes(searching) || item.accountAccrual.amount.toString().includes(searching) || item.accountEmission.amount.toString().includes(searching)
        ))
      } else {
        this.onSetFilter()
      }
    },
    openCorrectionDialog (account) {
      // console.log(account);
      this.dialogCorrectionVisible = true
      this.selectedCorrectionAccount = account
    },
    openDialog (account) {
      console.log(account)
      this.dialogVisible = true
      this.selectedAccount = account
    },
    search (input) {
      console.log('search', input)
      if (input.length < 1) { return [] }
      const arr = this.accounts.map(m => {
        return Object.values(m).filter(f => {
          if (f !== null) {
            if (f.toString().includes(input)) {
              return f
            }
          }
        })
      }).filter(fl => fl.length > 0).map(mp => { return { searched: mp[0] } })

      console.log('arr', arr)
      return arr
    },
    setItem (data) {
      return Reflect.construct(AccountListViewModel, [
        data.campaign,
        data.accountAccrual,
        data.accountEmission
      ])
    }
  }
}
</script>

<style scoped></style>
